


<div class="banner_header">
    <div class="row" style="margin: 0px;">
        <div class="col-md-6">
            <h2>Exam Fees State</h2>
        </div>

    </div>

</div>

<!--Content Start-->
<section class="section_box_one">
    <div class="container">
        <h2>CTS CBT Main Exam AITT-2022 Fee Payment link </h2>
        
    </div>
</section>
<!--Content End-->

<div class="container payment_cls">

    <div class="alert alert-success" role="alert" *ngIf="bool_success">
        {{reciveuserstatus}}
      </div>

    <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
        {{reciveuserstatus}}
      </div>
  
    <div class="container" *ngIf="bool_form_content">
        <div class="row d-flex justify-content-center">
            <div class="col-md-4 ">
                <!--FORM1 Start-->
                <div class="card-body" *ngIf="bool_useridForm">
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
                          <div class="form-row">
                            
                            <div class="form-group col-12">
                                <label>User ID <span class="clr_red"> * </span>
                                <p class="small"> (Your NCVET User ID eg: CFIXXXXXX_A OR CFIXXXXXX_C )  </p></label>
                                <input type="text" formControlName="userid" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.userid.errors }" maxlength="50"
                                    placeholder="Enter Your User ID" (keypress)="omit_spl($event)" />
                                <div *ngIf="submitted && f.userid.errors" class="invalid-feedback">
                                    <div *ngIf="f.userid.errors.required">Enter Your User ID</div>
                                </div>
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Submit</button>
                                  </div>
                                  <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                    Please Wait...
                                    </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <!--Form1 End-->

                  <!--FORM2 Start-->
                  <div class="card-body" *ngIf="bool_otpForm">
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()">
                          <div class="form-row">
                            <div class="form-group col-12">
                                <label>OTP <span class="clr_red"> * </span></label>
                                <input type="text" formControlName="userid" [(ngModel)]="reciveuserid" class="form-control" hidden
                                    />

                                <input type="text" formControlName="otp" class="form-control"
                                    [ngClass]="{ 'is-invalid': submittedOtp && g.otp.errors }" maxlength="50"
                                    placeholder="Enter Your OTP" (keypress)="omit_spl($event)"  />
                                <div *ngIf="submittedOtp && g.otp.errors" class="invalid-feedback">
                                    <div *ngIf="g.otp.errors.required">Enter Your User ID</div>
                                </div>
                                <p class="pad-btm-empty">Enter OTP sent in your registered email or mobile </p>
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Submit</button>
                                  </div>
                                  <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                    Please Wait...
                                    </div>

                              </div>
                          </div>
                      </form>
                  </div>
                  <!--FORM2 End-->
            </div>
        </div>
    </div>

     <!--FORM3 Start-->
     <div class="card-body" *ngIf="bool_itiForm">
        <form [formGroup]="itiForm" (ngSubmit)="onItiSubmit()">
            <div class="form-row">

              <div class="form-group col-3">
                  <label>State</label>

                  <input type="text" formControlName="statekey" [(ngModel)]="sel_statekey" class="form-control" readonly hidden
                  />
                  <input type="text" formControlName="state" [(ngModel)]="sel_stateName" class="form-control" readonly
                  />
                  <!-- <select formControlName="state" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && h.state.errors }" (change)="onChangeState($event)">
                    <option [selected]="true" value="" [disabled]="true">Select State</option>
                    <option *ngFor="let country of ListState" [value]="country.statekey">
                      {{ country.statename }}
                    </option>
                  </select>
                  <div *ngIf="submitted && h.state.errors" class="invalid-feedback">
                    <div *ngIf="h.state.errors.required">Select Your State</div>
                  </div> -->
                </div>

              <!-- <div class="form-group col-12">
                  <label>MIS Code <span class="clr_red"> * </span></label>
                  <input type="text" formControlName="iticode" [(ngModel)]="reciveiticode" class="form-control" readonly
                      />
              </div> -->
               

            </div>
            <hr>
            <div class="form-row">
                <div class="form-group col-12">
                    <div class="text-center">
                        <button class="btn btn-primary mr-1">Click to Select Institute </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!--FORM3 End-->

</div>
